"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbTrustedLogin = void 0;
const repository_1 = require("../../../features/authoriser/infra/repositories/checkTrustedVerificationStatus/repository");
const repository_2 = require("../../../features/authoriser/infra/repositories/trustedLoginSession/repository");
const types_1 = require("../../../features/authoriser/types");
const repository_3 = require("../../../features/authoriser/infra/repositories/repository");
const timeOut_helper_1 = require("../../../features/timeOut/helpers/timeOut.helper");
const events_1 = require("../../../features/events");
const baseTrusted_1 = require("./baseTrusted");
class VerificationError extends Error {
    constructor(source, error) {
        super('Error in Trusted Verification Status');
        this.source = source;
        this.name = 'trustedVerificationStatusError';
        this.errorData = error;
    }
}
class SessionError extends Error {
    constructor(source, error) {
        super('Error in Trusted Session Verify');
        this.source = source;
        this.name = 'trustedSessionVerifyError';
        this.errorData = error;
    }
}
class MbTrustedLogin extends baseTrusted_1.BaseTrusted {
    constructor(api, data, session, asyncConnectionUrlConfig, trustedLoginUrlConfig, eventBus) {
        super(api, data, session, asyncConnectionUrlConfig);
        this.doRetry = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield (0, repository_3.regeneratePUSH)(this.api, this.progressId, this.trustedLoginUrlConfig.retry);
                this.data = Object.assign(Object.assign({}, this.data), { biometricId: data.biometricId });
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.TRUSTED_CONFIRMATION_LOGIN, success: true }, this.eventBus);
            }
            catch (_) {
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.TRUSTED_CONFIRMATION_LOGIN, success: false }, this.eventBus);
            }
        });
        this.trustedLoginUrlConfig = trustedLoginUrlConfig;
        this.eventBus = eventBus;
    }
    doVerify() {
        return __awaiter(this, void 0, void 0, function* () {
            this.closeAsyncConnection();
            const checkVerificationData = {
                biometricId: this.data.biometricId,
            };
            try {
                const isVerified = yield repository_1.trustedVerificationStatusRepository.isVerified(this.api, this.progressId, checkVerificationData, this.trustedLoginUrlConfig.verify);
                if (!isVerified) {
                    throw new Error('Validation from the trusted device is required');
                }
            }
            catch (error) {
                throw new VerificationError('VerificationError', error);
            }
            try {
                const session = yield repository_2.trustedLoginChallengeSessionRepository.getSession(this.api, this.progressId, this.trustedLoginUrlConfig.getSession);
                this.updateSession(session);
            }
            catch (error) {
                throw new SessionError('SessionError', error);
            }
            return {
                type: types_1.ChallengeType.NONE,
                progressId: this.progressId,
            };
        });
    }
    updateSession(session) {
        var _a, _b;
        this.session.updateData(Object.assign(Object.assign({}, session), { username: (_b = (_a = this.session.getData()) === null || _a === void 0 ? void 0 : _a.username) !== null && _b !== void 0 ? _b : '', timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(session.expiresIn) }));
    }
}
exports.MbTrustedLogin = MbTrustedLogin;
//# sourceMappingURL=trustedLogin.js.map